module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }